export const ACCOUNTED_DETAIL_ADMIN_LIVE_SUCCESS = "ACCOUNTED_DETAIL_ADMIN_LIVE_SUCCESS";
export const ACCOUNTED_DETAIL_ADMIN_LIVE_ERROR = "ACCOUNTED_DETAIL_ADMIN_LIVE_ERROR";
export const ACCOUNTED_DETAIL_ADMIN_LIVE_START = "ACCOUNTED_DETAIL_ADMIN_LIVE_START";
export const CLEAR_LIVE_TRIP_ACCOUNT_DETAIL='CLEAR_LIVE_TRIP_ACCOUNT_DETAIL'